import React, { Component } from 'react';
import Loader from 'react-loader-spinner';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';


export default class ClientConfigSettings extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            successResp: true,
            disabled: false,
            editedId: '-1',
            hideDeletePopup: true,
            propsId: null,
            appId: null
        }
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: true,
            });
        };

        this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteDetails(this.state.propsId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: true });
            }
        }];

        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchStoreDataApi();
            thisController.fetchClientConfigDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchStoreDataApi(event.projectId);
            thisController.fetchClientConfigDataApi(event.projectId);
        });
    }

    addRow = () => {
        this.state.data.unshift({});
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    fetchStoreDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var storeComponent = this;
        $.ajax({
            url: "/api/app",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    if (Object.keys(res.result.app).length > 0) {
                        storeComponent.state.appId = res.result.app.id;
                        storeComponent.setState(storeComponent.state);
                    } else {
                        storeComponent.notifyMissingAppDetails("Please fill basic app details");
                        setTimeout(() => {
                            window.location.href = window.origin + "/platform/projectmgmt/bot-store";
                        }, 1000)
                    }
                } else {
                    storeComponent.notifyMissingAppDetails("Please fill basic app details");
                    setTimeout(() => {
                        window.location.href = window.origin + "/platform/projectmgmt/bot-store";
                    }, 1000)
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyMissingAppDetails = (message) => {
        toast.dismiss();
        toast(<b> <img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    fetchClientConfigDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var storeComponent = this;
        $.ajax({
            url: "/api/app-param",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    storeComponent.state.data = res.result;
                    storeComponent.state.disabled = false;
                    storeComponent.state.editedId = "-1";
                    storeComponent.setState(storeComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    validateDetails = (paramName, paramDescription) => {
        if (paramName.trim() == "" ||
            paramDescription.trim() == "") {
            this.notifyMsgFieldEmpty();
            return false;
        } else {
            return true;
        }
    }

    saveDetails = (props, e) => {
        let storeComponent = this;
        let paramName = document.getElementById("paramName" + props.index).innerText.trim();
        let paramDescription = document.getElementById("paramDescription" + props.index).innerText.trim();
        if (storeComponent.validateDetails(paramName, paramDescription)) {
            let data = {
                templateProjectId: localStorage.getItem('currentProjectId'),
                appId: storeComponent.state.appId,
                paramName: paramName,
                paramDescription: paramDescription,
                possibleValues: document.getElementById("possibleValues" + props.index).innerText,
                optional: document.getElementById("optional" + props.index).checked
            }
            $.ajax({
                url: "/api/app-param",
                type: 'POST',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        storeComponent.notifySuccessToast("Client-Configurable settings added Successfully");
                        storeComponent.fetchClientConfigDataApi();
                    } else {
                        storeComponent.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    updateDetails = (props, e) => {
        let storeComponent = this;
        let paramName = document.getElementById("paramName" + props.index).innerText.trim();
        let paramDescription = document.getElementById("paramDescription" + props.index).innerText.trim();
        if (storeComponent.validateDetails(paramName, paramDescription)) {
            let data = {
                id: props.original.id,
                templateProjectId: localStorage.getItem('currentProjectId'),
                appId: storeComponent.state.appId,
                paramName: paramName,
                paramDescription: paramDescription,
                possibleValues: document.getElementById("possibleValues" + props.index).innerText,
                optional: document.getElementById("optional" + props.index).checked
            }
            $.ajax({
                url: "/api/app-param",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        storeComponent.notifySuccessToast("Basic Settings updated Successfully");
                        storeComponent.state.editedId = "-1";
                        storeComponent.setState(storeComponent.state);
                        storeComponent.fetchClientConfigDataApi();
                    } else {
                        storeComponent.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable = (props, e) => {
        this.state.editedId = props.original.id;
        this.setState(this.state);
    }

    deleteDetails = (id) => {
        let storeComponent = this;
        $.ajax({
            url: "/api/app-param/" + id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    storeComponent.setState({ hideDeletePopup: true });
                    storeComponent.fetchClientConfigDataApi();
                    storeComponent.notifySuccessToast("Client-Configurable Settings deleted Successfully");
                } else {
                    storeComponent.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    refreshData = () => {
        this.fetchClientConfigDataApi();
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: <b>Name</b>,
                accessor: 'paramName',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == null) ? '2px' : 'none',
                        paddingLeft: '2px'
                    }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"paramName" + props.index}
                >{props.original.paramName}</div>
                )
            },
            {
                Header: <b>Description</b>,
                accessor: 'paramDescription',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px'
                    }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"paramDescription" + props.index}
                >{props.original.paramDescription}</div>)
            }, {
                Header: <b>Possible Values</b>,
                accessor: 'possibleValues',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px'
                    }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"possibleValues" + props.index}
                >{props.original.possibleValues}</div>)
            }, {
                Header: <b>Is Optional</b>,
                accessor: 'optional',
                width: 150,
                sortable: false,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"optional" + props.index}
                                    defaultChecked={props.original.optional}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            }, {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">
                        {/* edit button */}
                        <div style={{ marginTop: '-9px' }}>
                            <p>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive"
                                        title={(props.original.id == undefined) || (props.original.id == this.state.editedId) ? 'Save' : 'Edit'}
                                        style={{
                                            marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px',
                                            padding: '1px', cursor: 'pointer'
                                        }}
                                        src={(props.original.id == null) ?
                                            this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                                this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == null) ?
                                                this.saveDetails(props, e) :
                                                (props.original.id == this.state.editedId) ?
                                                    this.updateDetails(props, e) :
                                                    this.makeCelleditable(props, e);
                                        }}
                                    /></button>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        title="Delete"
                                        style={{
                                            marginTop: '6px', backgroundColor: '#282a65',
                                            borderRadius: '5px', padding: '1px', cursor: 'pointer'
                                        }}
                                        onClick={() => {(props.original.id) === undefined ?
                                            this.fetchClientConfigDataApi() :
                                            this.setState({
                                                hideDeletePopup: false,
                                                propsId: props.original.id
                                            })
                                        }}
                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />

                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '24px', marginLeft: '-2px'
                                }}>Client-Configurable Settings</h6>
                            </div>
                            {/* Add button and refresh button*/}
                            <div className="col-sm-6" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow} >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-12 ">
                                    <div className="card" >
                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={5}
                                            pageSizeOptions={[5, 10, 15]}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                        header="Client-Configurable Settings" showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={!this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete client-Configurable settings ?<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/appStore/ClientConfigSettings.js